<template>
  <div>
    <button v-if="as_icon" class="button is-small" v-on:click="showHelpModal()">
      <b-icon class="help-button" type="is-success" pack="fas" icon="question-circle"></b-icon>
    </button>
    <a v-else :href="url">{{link_text}}</a>
  </div>
</template>

<script>
import HelpModal from "../../modals/HelpModal"

export default {
  props: ["url", "as_icon", "link_text"],
  components: {
    HelpModal
  },
  methods: {
    showHelpModal: function () {
      this.$modal.open({
        parent: this,
        component: HelpModal,
        hasModalCard: true,
        props: {
          url: this.url
        }
      })
    }
  },
  watch: {
    url: function (newVal, oldVal) { // watch it
      console.log('Url changed: ', newVal, ' | was: ', oldVal)
    }
  },
  mounted() {
    console.log(this.url)
  }
}
</script>

<style scoped>
.g {
  background: none
}

.button {
  border: 0;
  background: none;
}

a:hover {
  color: limegreen;
}
</style>